const edgeOfferingsState = {
    edgeOffering: undefined,
    edgeOfferings: undefined,
    requestingCreateEdgeOffering: false,
    requestingEdgeOffering: false,
    requestingEdgeOfferings: false,
    requestingModifyEdgeOffering: false,
    requestingRemoveEdgeOffering: false,
    requestingTargetProfileEdgeOfferings: false,
    targetProfileEdgeOfferings: undefined
};
export default edgeOfferingsState;
